import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/",
          name: "dashboard",
          component: () => import("@/view/pages/Dashboard.vue")
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/profile/Profile.vue")
        },
        {
          path: "/profile/sign-ins",
          name: "sign-ins",
          component: () => import("@/view/pages/profile/SignIns.vue")
        },
        {
          path: "/profile/user-tokens",
          name: "user-tokens",
          component: () => import("@/view/pages/profile/UserTokens.vue")
        },
        {
          path: "/profile/api-tokens",
          name: "api-tokens",
          component: () => import("@/view/pages/profile/ApiTokens.vue")
        },
        {
          path: "/destinations",
          name: "destinations-index",
          component: () => import("@/view/pages/destinations/Index.vue")
        },
        {
          path: "/destinations/create",
          name: "destinations-create",
          component: () => import("@/view/pages/destinations/Create.vue")
        },
        {
          path: "/destinations/:id",
          name: "destinations-show",
          component: () => import("@/view/pages/destinations/Show.vue")
        },
        {
          path: "/programs",
          name: "programs-index",
          component: () => import("@/view/pages/programs/Index.vue")
        },
        {
          path: "/programs/create",
          name: "programs-create",
          component: () => import("@/view/pages/programs/Create.vue")
        },
        {
          path: "/programs/:id/files",
          name: "programs-files",
          component: () => import("@/view/pages/programs/UploadFile.vue")
        },
        {
          path: "/programs/:id",
          name: "programs-show",
          component: () => import("@/view/pages/programs/Show.vue")
        },
        {
          path: "/programs/:id/edit",
          name: "programs-edit",
          component: () => import("@/view/pages/programs/Edit.vue")
        },
        {
          path: "/programs/:id/schedules",
          name: "programs-schedules",
          component: () => import("@/view/pages/programs/Schedules.vue")
        },
        {
          path: "/programs/:program/lives/:live",
          name: "lives-show",
          component: () => import("@/view/pages/lives/Show.vue")
        },
        {
          path: "/liveDestinations/:id",
          name: "live-destinations-show",
          component: () => import("@/view/pages/liveDestinations/Show.vue")
        },
        {
          path: "/channels-index",
          name: "channels-index",
          component: () => import("@/view/pages/channels/Index.vue")
        },
        {
          path: "/channels/create",
          name: "channels-create",
          component: () => import("@/view/pages/channels/Create.vue")
        },
        {
          path: "/channels/:id",
          name: "channels-show",
          component: () => import("@/view/pages/channels/Show.vue")
        },
        {
          path: "/channels/:id/edit",
          name: "channels-edit",
          component: () => import("@/view/pages/channels/Edit.vue")
        },
        {
          path: "/files",
          name: "files-index",
          component: () => import("@/view/pages/files/Index.vue")
        },
        {
          path: "/transactions",
          name: "transactions-index",
          component: () => import("@/view/pages/transactions/Index.vue")
        },
        {
          path: "/receipts/live",
          name: "receipts-lives-index",
          component: () => import("@/view/pages/receipts/live/Index.vue")
        },
        {
          path: "/receipts/live/:id",
          name: "receipts-lives-show",
          component: () => import("@/view/pages/receipts/live/Show.vue")
        },
        {
          path: "/receipts/storage",
          name: "receipts-storage-index",
          component: () => import("@/view/pages/receipts/storage/Index.vue")
        },
        {
          path: "/receipts/storage/:id",
          name: "receipts-storage-show",
          component: () => import("@/view/pages/receipts/storage/Show.vue")
        },
        {
          path: "/tickets",
          name: "tickets-index",
          component: () => import("@/view/pages/tickets/Index.vue")
        },
        {
          path: "/tickets/create",
          name: "tickets-create",
          component: () => import("@/view/pages/tickets/Create.vue")
        },
        {
          path: "/tickets/:id",
          name: "tickets-show",
          component: () => import("@/view/pages/tickets/Show.vue")
        },
        {
          path: "/calculator",
          name: "calculator-index",
          component: () => import("@/view/pages/calculator.vue")
        }
      ]
    },
    {
      path: "/company",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/company",
          name: "company-dashboard",
          component: () => import("@/view/pages/company/Dashboard.vue")
        },
        {
          path: "/company/users",
          name: "company-users-index",
          component: () => import("@/view/pages/company/users/Index.vue")
        },
        {
          path: "/company/users/create",
          name: "company-users-create",
          component: () => import("@/view/pages/company/users/Create.vue")
        },
        {
          path: "/company/users/:id",
          name: "company-users-show",
          component: () => import("@/view/pages/company/users/Show.vue")
        },
        {
          path: "/company/users/:id/edit",
          name: "company-users-edit",
          component: () => import("@/view/pages/company/users/Edit.vue")
        },
        {
          path: "/company/users/:id/destinations/create",
          name: "company-destinations-create",
          component: () => import("@/view/pages/destinations/Create.vue")
        },
        {
          path: "/company/users/:id/programs/create",
          name: "company-programs-create",
          component: () => import("@/view/pages/programs/Create.vue")
        },
        {
          path: "/company/programs",
          name: "company-programs-index",
          component: () => import("@/view/pages/company/programs/Index.vue")
        },
        {
          path: "/company/programs/:id",
          name: "company-programs-show",
          component: () => import("@/view/pages/programs/Show.vue")
        },
        {
          path: "/company/programs/:id/edit",
          name: "company-programs-edit",
          component: () => import("@/view/pages/programs/Edit.vue")
        },
        {
          path: "/company/programs/:id/schedules",
          name: "company-programs-schedules",
          component: () => import("@/view/pages/programs/Schedules.vue")
        },
        {
          path: "/company/programs/:program/lives/:live",
          name: "company-lives-show",
          component: () => import("@/view/pages/lives/Show.vue")
        },
        {
          path: "/company/destinations",
          name: "company-destinations-index",
          component: () => import("@/view/pages/company/destinations/Index.vue")
        },
        {
          path: "/company/destinations/:id",
          name: "company-destinations-show",
          component: () => import("@/view/pages/destinations/Show.vue")
        },
        {
          path: "/company/lives",
          name: "company-lives",
          component: () => import("@/view/pages/company/lives/Lives.vue")
        },
        {
          path: "/company/active-lives",
          name: "company-active-lives",
          component: () => import("@/view/pages/company/lives/Active.vue")
        },
        {
          path: "/company/receipts/live",
          name: "company-receipts-lives-index",
          component: () => import("@/view/pages/receipts/live/Index.vue")
        },
        {
          path: "/company/receipts/live/:id",
          name: "company-receipts-lives-show",
          component: () => import("@/view/pages/receipts/live/Show.vue")
        },
        {
          path: "/company/receipts/storage",
          name: "company-receipts-storage-index",
          component: () => import("@/view/pages/receipts/storage/Index.vue")
        },
        {
          path: "/company/receipts/storage/:id",
          name: "company-receipts-storage-show",
          component: () => import("@/view/pages/receipts/storage/Show.vue")
        },
        {
          path: "/company/tickets",
          name: "company-tickets-index",
          component: () => import("@/view/pages/company/tickets/Index.vue")
        },
        {
          path: "/company/tickets/:id",
          name: "company-tickets-show",
          component: () => import("@/view/pages/tickets/Show.vue")
        },
        {
          path: "/company/bannedUsers",
          name: "company-banned-users-index",
          component: () => import("@/view/pages/company/bannedusers/Index.vue")
        },
        {
          path: "/company/banners",
          name: "company-banners-index",
          component: () => import("@/view/pages/company/banners/Index.vue")
        },
        {
          path: "/company/banners/create",
          name: "company-banners-create",
          component: () => import("@/view/pages/company/banners/Create.vue")
        }
      ]
    },
    {
      path: "/admin",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/admin/dashboard",
          name: "admin-dashboard",
          component: () => import("@/view/pages/admin/Dashboard.vue")
        },
        {
          path: "/admin/users",
          name: "admin-users-index",
          component: () => import("@/view/pages/admin/users/Index.vue")
        },
        {
          path: "/admin/users/create",
          name: "admin-users-create",
          component: () => import("@/view/pages/admin/users/Create.vue")
        },
        {
          path: "/admin/users/:id",
          name: "admin-users-show",
          component: () => import("@/view/pages/admin/users/Show.vue")
        },
        {
          path: "/admin/users/:id/edit",
          name: "admin-users-edit",
          component: () => import("@/view/pages/admin/users/Edit.vue")
        },
        {
          path: "/admin/users/:id/prices",
          name: "admin-users-prices",
          component: () => import("@/view/pages/admin/users/Prices.vue")
        },
        {
          path: "/admin/users/:id/destinations/create",
          name: "admin-destinations-create",
          component: () => import("@/view/pages/destinations/Create.vue")
        },
        {
          path: "/admin/users/:id/programs/create",
          name: "admin-programs-create",
          component: () => import("@/view/pages/programs/Create.vue")
        },
        {
          path: "/admin/programs",
          name: "admin-programs-index",
          component: () => import("@/view/pages/admin/programs/Index.vue")
        },
        {
          path: "/admin/programs/:id",
          name: "admin-programs-show",
          component: () => import("@/view/pages/programs/Show.vue")
        },
        {
          path: "/admin/programs/:id/edit",
          name: "admin-programs-edit",
          component: () => import("@/view/pages/programs/Edit.vue")
        },
        {
          path: "/admin/programs/:id/schedules",
          name: "admin-programs-schedules",
          component: () => import("@/view/pages/programs/Schedules.vue")
        },
        {
          path: "/admin/programs/:program/lives/:live",
          name: "admin-lives-show",
          component: () => import("@/view/pages/lives/Show.vue")
        },
        {
          path: "/admin/destinations",
          name: "admin-destinations-index",
          component: () => import("@/view/pages/admin/destinations/Index.vue")
        },
        {
          path: "/admin/destinations/:id",
          name: "admin-destinations-show",
          component: () => import("@/view/pages/destinations/Show.vue")
        },
        {
          path: "/admin/transactions",
          name: "admin-transactions-index",
          component: () => import("@/view/pages/admin/transactions/Index.vue")
        },
        {
          path: "/admin/users/:id/transactions/create",
          name: "admin-transactions-create",
          component: () => import("@/view/pages/admin/transactions/Create.vue")
        },
        {
          path: "/admin/lives",
          name: "admin-lives",
          component: () => import("@/view/pages/admin/lives/Lives.vue")
        },
        {
          path: "/admin/active-lives",
          name: "admin-active-lives",
          component: () => import("@/view/pages/admin/lives/Active.vue")
        },
        {
          path: "/admin/special-users",
          name: "admin-special-users",
          component: () => import("@/view/pages/admin/users/SpecialUsers.vue")
        },
        {
          path: "/admin/receipts/live",
          name: "admin-receipts-lives-index",
          component: () => import("@/view/pages/receipts/live/Index.vue")
        },
        {
          path: "/admin/receipts/live/:id",
          name: "admin-receipts-lives-show",
          component: () => import("@/view/pages/receipts/live/Show.vue")
        },
        {
          path: "/admin/receipts/storage",
          name: "admin-receipts-storage-index",
          component: () => import("@/view/pages/receipts/storage/Index.vue")
        },
        {
          path: "/admin/receipts/storage/:id",
          name: "admin-receipts-storage-show",
          component: () => import("@/view/pages/receipts/storage/Show.vue")
        },
        {
          path: "/admin/pricing",
          name: "admin-pricing",
          component: () => import("@/view/pages/admin/pricing/Index.vue")
        },
        {
          path: "/admin/prices",
          name: "admin-company-price",
          component: () => import("@/view/pages/admin/companies/Prices.vue")
        },
        {
          path: "/admin/companies",
          name: "admin-companies-index",
          component: () => import("@/view/pages/admin/companies/Index.vue")
        },
        {
          path: "/admin/companies/:id",
          name: "admin-companies-show",
          component: () => import("@/view/pages/admin/companies/Show.vue")
        },
        {
          path: "/admin/reports",
          name: "admin-reports-index",
          component: () => import("@/view/pages/admin/reports/Index.vue")
        },
        {
          path: "/admin/tickets",
          name: "admin-tickets-index",
          component: () => import("@/view/pages/admin/tickets/Index.vue")
        },
        {
          path: "/admin/tickets/:id",
          name: "admin-tickets-show",
          component: () => import("@/view/pages/tickets/Show.vue")
        },
        {
          path: "/admin/messages",
          name: "admin-messages-index",
          component: () => import("@/view/pages/admin/messages/Index.vue")
        },
        {
          path: "/admin/bannedusers",
          name: "admin-banned-users-index",
          component: () => import("@/view/pages/admin/bannedusers/Index.vue")
        },
        {
          path: "/admin/banners",
          name: "admin-banners-index",
          component: () => import("@/view/pages/admin/banners/Index.vue")
        },
        {
          path: "/admin/banners/create",
          name: "admin-banners-create",
          component: () => import("@/view/pages/admin/banners/Create.vue")
        },
        {
          path: "/admin/giftcards",
          name: "admin-gift-cards",
          component: () => import("@/view/pages/giftcards/Index.vue")
        },
        {
          path: "/admin/giftcards/create",
          name: "admin-gift-cards-create",
          component: () => import("@/view/pages/giftcards/Create.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Otp"),
      children: [
        {
          name: "otp",
          path: "/otp",
          component: () => import("@/view/pages/auth/Otp")
        }
      ]
    },
    {
      name: "sign-in",
      path: "/sign-in",
      component: () => import("@/view/pages/auth/SignIn")
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Login"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login")
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Login")
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    },
    {
      path: "/403",
      name: "403",
      component: () => import("@/view/pages/error/Error-6.vue")
    }
  ]
});
